import React, { useCallback, useState } from 'react';
import { Create, useRedirect } from 'react-admin';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';

import GroupSummary from './GroupSummary';
import FormTitleBar from '../../core/components/FormTitleBar';
import CreateToolbar from '../../core/components/CreateToolbar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import Confirm from '../../core/components/forked/layout/Confirm';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const noop = () => {};

const GroupTitle = ({ record }) => {
  return (
    <FormTitleBar
      type="Document Group"
      name=""
      status=""
      creation={true}
      showAvatar={true}
      avatarContent={'GR'}
      recordLabel="Group"
    />
  );
};

const GroupCreate = ({
  classes,
  hasDeletePermission,
  hasEditPermission,
  hasCreatePermission,
  userProfile,
  ...rest
}) => {
  const [whenBlockNavigation, setWhenBlockNavigation] = useState(false);
  const [whenGroupCreated, setWhenGroupCreated] = useState(false);
  const [data, setData] = useState(false);
  const redirect = useRedirect();

  const onSuccess = useCallback(({ data }) => {
    setData(data);
    setWhenGroupCreated(true);
  }, []);

  const redirectAfterConfirm = useCallback(() => {
    redirect('edit', rest.basePath, data.id);
  }, [data.id, redirect, rest.basePath]);

  return (
    <React.Fragment>
      <NavigationPrompt when={whenBlockNavigation} creation>
        {(isOpen, onConfirm, onCancel) => (
          <LeaveConfirm
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onCancel}
          />
        )}
      </NavigationPrompt>
      <Confirm
        title=""
        isOpen={whenGroupCreated}
        onConfirm={redirectAfterConfirm}
        content="ra.notification.group_created"
        showCancel={false}
        onClose={noop}
      />
      <Create
        // https://marmelab.com/react-admin/CreateEdit.html#onsuccess to know what mutationMode does
        mutationMode="pessimistic"
        title={<GroupTitle />}
        onSuccess={onSuccess}
        classes={{ noActions: classes.noActions }}
        {...rest}
      >
        <CustomSimpleForm
          initialValues={{ adminGroup: false }}
          toolbar={
            <CreateToolbar
              allowNavigationOnSave={() => setWhenBlockNavigation(false)}
            />
          }
          variant="standard"
          margin="normal"
        >
          <GroupSummary creation={true} />
          <FormSpy
            subscription={{ dirty: true }}
            onChange={props => setWhenBlockNavigation(props.dirty)}
          />
        </CustomSimpleForm>
      </Create>
    </React.Fragment>
  );
};

export default withStyles(styles)(GroupCreate);
